module.exports = {
  firebase: {
    'auth/wrong-password': 'ユーザー名とパスワードが一致しません。'
  },
  login: {
    fail: 'ユーザー名とパスワードが一致しません。',
    unexpected: 'サーバーに問題があります。',
    require: 'ユーザー名とパスワードを入力してください。'
  },
  box: {
    file: {
      upload: {
        item_name_in_use: '同名のファイルがあるためアップロードできませんでした。'
      },
      rename: {
        item_name_in_use: '同名のファイルがあるため変更できませんでした。',
        item_name_invalid: 'ファイル名が不適当です。'
      },
      open: {
        unsupported_media_type: 'このファイルはブラウザ上で閲覧できません。ダウンロードしてご確認ください。'
      }
    },
    folder: {
      rename: {
        item_name_in_use: '同名のフォルダがあるため変更できませんでした。',
        item_name_invalid: 'フォルダ名が不適当です。'
      },
      mkdir: {
        item_name_in_use: '同名のフォルダがあるため作成できませんでした。',
        item_name_invalid: 'フォルダ名が不適当です。'
      }
    },
    item: {
      move: {
        item_name_in_use: '同名のアイテムが移動先にあるため中止されました。'
      }
    }
  },
  zip: {
    search: {
      unmatch: '一致する住所がありませんでした。'
    }
  },
  xlsx: {
    read: {
      out_of_sheets: '指定したシートは存在しませんでした。'
    }
  }
}
